// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.2.4
//   protoc               v5.28.2
// source: stcs_wapp_svc_user.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { grpc } from "@improbable-eng/grpc-web";
import { BrowserHeaders } from "browser-headers";
import { Observable } from "rxjs";
import { take } from "rxjs/operators";
import { GenericPayloadResponse } from "./stcs_commons.entity";
import { NumberFormatOptions } from "./stcs_user.entity";

export const protobufPackage = "stcs_cmw";

export interface UserGetRequest {
  euuid: string;
}

export interface UserUpdateRequest {
  ref_id_user: string;
  name_display: string;
  name_first: string;
  name_last: string;
  title: string;
  user_picture_bytes: Uint8Array;
  sel_lang: string;
  number_format_options: NumberFormatOptions | undefined;
  sel_theme: string;
  sel_ref_id_org: string;
  sel_ref_id_comp: string;
  sel_ref_id_plan: string;
  newsletter_subscribed: boolean;
}

export interface UserDeleteRequest {
  ref_id_user: string;
}

function createBaseUserGetRequest(): UserGetRequest {
  return { euuid: "" };
}

export const UserGetRequest: MessageFns<UserGetRequest> = {
  encode(message: UserGetRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.euuid !== "") {
      writer.uint32(10).string(message.euuid);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UserGetRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUserGetRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.euuid = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UserGetRequest {
    return { euuid: isSet(object.euuid) ? globalThis.String(object.euuid) : "" };
  },

  toJSON(message: UserGetRequest): unknown {
    const obj: any = {};
    if (message.euuid !== "") {
      obj.euuid = message.euuid;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UserGetRequest>, I>>(base?: I): UserGetRequest {
    return UserGetRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UserGetRequest>, I>>(object: I): UserGetRequest {
    const message = createBaseUserGetRequest();
    message.euuid = object.euuid ?? "";
    return message;
  },
};

function createBaseUserUpdateRequest(): UserUpdateRequest {
  return {
    ref_id_user: "",
    name_display: "",
    name_first: "",
    name_last: "",
    title: "",
    user_picture_bytes: new Uint8Array(0),
    sel_lang: "",
    number_format_options: undefined,
    sel_theme: "",
    sel_ref_id_org: "",
    sel_ref_id_comp: "",
    sel_ref_id_plan: "",
    newsletter_subscribed: false,
  };
}

export const UserUpdateRequest: MessageFns<UserUpdateRequest> = {
  encode(message: UserUpdateRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ref_id_user !== "") {
      writer.uint32(10).string(message.ref_id_user);
    }
    if (message.name_display !== "") {
      writer.uint32(18).string(message.name_display);
    }
    if (message.name_first !== "") {
      writer.uint32(26).string(message.name_first);
    }
    if (message.name_last !== "") {
      writer.uint32(34).string(message.name_last);
    }
    if (message.title !== "") {
      writer.uint32(42).string(message.title);
    }
    if (message.user_picture_bytes.length !== 0) {
      writer.uint32(50).bytes(message.user_picture_bytes);
    }
    if (message.sel_lang !== "") {
      writer.uint32(58).string(message.sel_lang);
    }
    if (message.number_format_options !== undefined) {
      NumberFormatOptions.encode(message.number_format_options, writer.uint32(66).fork()).join();
    }
    if (message.sel_theme !== "") {
      writer.uint32(74).string(message.sel_theme);
    }
    if (message.sel_ref_id_org !== "") {
      writer.uint32(82).string(message.sel_ref_id_org);
    }
    if (message.sel_ref_id_comp !== "") {
      writer.uint32(90).string(message.sel_ref_id_comp);
    }
    if (message.sel_ref_id_plan !== "") {
      writer.uint32(106).string(message.sel_ref_id_plan);
    }
    if (message.newsletter_subscribed !== false) {
      writer.uint32(96).bool(message.newsletter_subscribed);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UserUpdateRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUserUpdateRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ref_id_user = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name_display = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.name_first = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.name_last = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.title = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.user_picture_bytes = reader.bytes();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.sel_lang = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.number_format_options = NumberFormatOptions.decode(reader, reader.uint32());
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.sel_theme = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.sel_ref_id_org = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.sel_ref_id_comp = reader.string();
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.sel_ref_id_plan = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.newsletter_subscribed = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UserUpdateRequest {
    return {
      ref_id_user: isSet(object.ref_id_user) ? globalThis.String(object.ref_id_user) : "",
      name_display: isSet(object.name_display) ? globalThis.String(object.name_display) : "",
      name_first: isSet(object.name_first) ? globalThis.String(object.name_first) : "",
      name_last: isSet(object.name_last) ? globalThis.String(object.name_last) : "",
      title: isSet(object.title) ? globalThis.String(object.title) : "",
      user_picture_bytes: isSet(object.user_picture_bytes)
        ? bytesFromBase64(object.user_picture_bytes)
        : new Uint8Array(0),
      sel_lang: isSet(object.sel_lang) ? globalThis.String(object.sel_lang) : "",
      number_format_options: isSet(object.number_format_options)
        ? NumberFormatOptions.fromJSON(object.number_format_options)
        : undefined,
      sel_theme: isSet(object.sel_theme) ? globalThis.String(object.sel_theme) : "",
      sel_ref_id_org: isSet(object.sel_ref_id_org) ? globalThis.String(object.sel_ref_id_org) : "",
      sel_ref_id_comp: isSet(object.sel_ref_id_comp) ? globalThis.String(object.sel_ref_id_comp) : "",
      sel_ref_id_plan: isSet(object.sel_ref_id_plan) ? globalThis.String(object.sel_ref_id_plan) : "",
      newsletter_subscribed: isSet(object.newsletter_subscribed)
        ? globalThis.Boolean(object.newsletter_subscribed)
        : false,
    };
  },

  toJSON(message: UserUpdateRequest): unknown {
    const obj: any = {};
    if (message.ref_id_user !== "") {
      obj.ref_id_user = message.ref_id_user;
    }
    if (message.name_display !== "") {
      obj.name_display = message.name_display;
    }
    if (message.name_first !== "") {
      obj.name_first = message.name_first;
    }
    if (message.name_last !== "") {
      obj.name_last = message.name_last;
    }
    if (message.title !== "") {
      obj.title = message.title;
    }
    if (message.user_picture_bytes.length !== 0) {
      obj.user_picture_bytes = base64FromBytes(message.user_picture_bytes);
    }
    if (message.sel_lang !== "") {
      obj.sel_lang = message.sel_lang;
    }
    if (message.number_format_options !== undefined) {
      obj.number_format_options = NumberFormatOptions.toJSON(message.number_format_options);
    }
    if (message.sel_theme !== "") {
      obj.sel_theme = message.sel_theme;
    }
    if (message.sel_ref_id_org !== "") {
      obj.sel_ref_id_org = message.sel_ref_id_org;
    }
    if (message.sel_ref_id_comp !== "") {
      obj.sel_ref_id_comp = message.sel_ref_id_comp;
    }
    if (message.sel_ref_id_plan !== "") {
      obj.sel_ref_id_plan = message.sel_ref_id_plan;
    }
    if (message.newsletter_subscribed !== false) {
      obj.newsletter_subscribed = message.newsletter_subscribed;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UserUpdateRequest>, I>>(base?: I): UserUpdateRequest {
    return UserUpdateRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UserUpdateRequest>, I>>(object: I): UserUpdateRequest {
    const message = createBaseUserUpdateRequest();
    message.ref_id_user = object.ref_id_user ?? "";
    message.name_display = object.name_display ?? "";
    message.name_first = object.name_first ?? "";
    message.name_last = object.name_last ?? "";
    message.title = object.title ?? "";
    message.user_picture_bytes = object.user_picture_bytes ?? new Uint8Array(0);
    message.sel_lang = object.sel_lang ?? "";
    message.number_format_options =
      (object.number_format_options !== undefined && object.number_format_options !== null)
        ? NumberFormatOptions.fromPartial(object.number_format_options)
        : undefined;
    message.sel_theme = object.sel_theme ?? "";
    message.sel_ref_id_org = object.sel_ref_id_org ?? "";
    message.sel_ref_id_comp = object.sel_ref_id_comp ?? "";
    message.sel_ref_id_plan = object.sel_ref_id_plan ?? "";
    message.newsletter_subscribed = object.newsletter_subscribed ?? false;
    return message;
  },
};

function createBaseUserDeleteRequest(): UserDeleteRequest {
  return { ref_id_user: "" };
}

export const UserDeleteRequest: MessageFns<UserDeleteRequest> = {
  encode(message: UserDeleteRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ref_id_user !== "") {
      writer.uint32(10).string(message.ref_id_user);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UserDeleteRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUserDeleteRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ref_id_user = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UserDeleteRequest {
    return { ref_id_user: isSet(object.ref_id_user) ? globalThis.String(object.ref_id_user) : "" };
  },

  toJSON(message: UserDeleteRequest): unknown {
    const obj: any = {};
    if (message.ref_id_user !== "") {
      obj.ref_id_user = message.ref_id_user;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UserDeleteRequest>, I>>(base?: I): UserDeleteRequest {
    return UserDeleteRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UserDeleteRequest>, I>>(object: I): UserDeleteRequest {
    const message = createBaseUserDeleteRequest();
    message.ref_id_user = object.ref_id_user ?? "";
    return message;
  },
};

export interface StcsWappSvcUser {
  user_get(request: DeepPartial<UserGetRequest>, metadata?: grpc.Metadata): Observable<GenericPayloadResponse>;
  user_update(request: DeepPartial<UserUpdateRequest>, metadata?: grpc.Metadata): Observable<GenericPayloadResponse>;
  user_delete(request: DeepPartial<UserDeleteRequest>, metadata?: grpc.Metadata): Observable<GenericPayloadResponse>;
}

export class StcsWappSvcUserClientImpl implements StcsWappSvcUser {
  private readonly rpc: Rpc;

  constructor(rpc: Rpc) {
    this.rpc = rpc;
    this.user_get = this.user_get.bind(this);
    this.user_update = this.user_update.bind(this);
    this.user_delete = this.user_delete.bind(this);
  }

  user_get(request: DeepPartial<UserGetRequest>, metadata?: grpc.Metadata): Observable<GenericPayloadResponse> {
    return this.rpc.unary(StcsWappSvcUseruser_getDesc, UserGetRequest.fromPartial(request), metadata);
  }

  user_update(request: DeepPartial<UserUpdateRequest>, metadata?: grpc.Metadata): Observable<GenericPayloadResponse> {
    return this.rpc.unary(StcsWappSvcUseruser_updateDesc, UserUpdateRequest.fromPartial(request), metadata);
  }

  user_delete(request: DeepPartial<UserDeleteRequest>, metadata?: grpc.Metadata): Observable<GenericPayloadResponse> {
    return this.rpc.unary(StcsWappSvcUseruser_deleteDesc, UserDeleteRequest.fromPartial(request), metadata);
  }
}

export const StcsWappSvcUserDesc = { serviceName: "stcs_cmw.StcsWappSvcUser" };

export const StcsWappSvcUseruser_getDesc: UnaryMethodDefinitionish = {
  methodName: "user_get",
  service: StcsWappSvcUserDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return UserGetRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = GenericPayloadResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const StcsWappSvcUseruser_updateDesc: UnaryMethodDefinitionish = {
  methodName: "user_update",
  service: StcsWappSvcUserDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return UserUpdateRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = GenericPayloadResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const StcsWappSvcUseruser_deleteDesc: UnaryMethodDefinitionish = {
  methodName: "user_delete",
  service: StcsWappSvcUserDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return UserDeleteRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = GenericPayloadResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

interface UnaryMethodDefinitionishR extends grpc.UnaryMethodDefinition<any, any> {
  requestStream: any;
  responseStream: any;
}

type UnaryMethodDefinitionish = UnaryMethodDefinitionishR;

interface Rpc {
  unary<T extends UnaryMethodDefinitionish>(
    methodDesc: T,
    request: any,
    metadata: grpc.Metadata | undefined,
  ): Observable<any>;
}

export class GrpcWebImpl {
  private host: string;
  private options: {
    transport?: grpc.TransportFactory;

    debug?: boolean;
    metadata?: grpc.Metadata;
    upStreamRetryCodes?: number[];
  };

  constructor(
    host: string,
    options: {
      transport?: grpc.TransportFactory;

      debug?: boolean;
      metadata?: grpc.Metadata;
      upStreamRetryCodes?: number[];
    },
  ) {
    this.host = host;
    this.options = options;
  }

  unary<T extends UnaryMethodDefinitionish>(
    methodDesc: T,
    _request: any,
    metadata: grpc.Metadata | undefined,
  ): Observable<any> {
    const request = { ..._request, ...methodDesc.requestType };
    const maybeCombinedMetadata = metadata && this.options.metadata
      ? new BrowserHeaders({ ...this.options?.metadata.headersMap, ...metadata?.headersMap })
      : metadata ?? this.options.metadata;
    return new Observable((observer) => {
      grpc.unary(methodDesc, {
        request,
        host: this.host,
        metadata: maybeCombinedMetadata ?? {},
        ...(this.options.transport !== undefined ? { transport: this.options.transport } : {}),
        debug: this.options.debug ?? false,
        onEnd: (next) => {
          if (next.status !== 0) {
            const err = new GrpcWebError(next.statusMessage, next.status, next.trailers);
            observer.error(err);
          } else {
            observer.next(next.message as any);
            observer.complete();
          }
        },
      });
    }).pipe(take(1));
  }
}

function bytesFromBase64(b64: string): Uint8Array {
  if ((globalThis as any).Buffer) {
    return Uint8Array.from(globalThis.Buffer.from(b64, "base64"));
  } else {
    const bin = globalThis.atob(b64);
    const arr = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; ++i) {
      arr[i] = bin.charCodeAt(i);
    }
    return arr;
  }
}

function base64FromBytes(arr: Uint8Array): string {
  if ((globalThis as any).Buffer) {
    return globalThis.Buffer.from(arr).toString("base64");
  } else {
    const bin: string[] = [];
    arr.forEach((byte) => {
      bin.push(globalThis.String.fromCharCode(byte));
    });
    return globalThis.btoa(bin.join(""));
  }
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export class GrpcWebError extends globalThis.Error {
  constructor(message: string, public code: grpc.Code, public metadata: grpc.Metadata) {
    super(message);
  }
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
